// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"448":"component---src-templates-dsg-js","479":"component---src-pages-ssr-js","678":"component---src-pages-index-js"}[chunkId] + "-" + {"448":"d5d083d3a1e69824768b","479":"4998e2a9b4b9017005f2","678":"7bcfacfa2cbd279ec325"}[chunkId] + ".js";
};